const pricingModelLabelMap = {
  SUBSCRIPTION_PREPAID: 'Fixed',
  SUBSCRIPTION_POSTPAID: 'Fixed',
  RECURRING_PREPAID: 'Variable',
  RECURRING_POSTPAID: 'Variable',
  UNSCHEDULED_PREPAID: 'Auto Reload',
  UNSCHEDULED_POSTPAID: 'Auto Reload',
  INSTALLMENT_PREPAID: 'Fixed',
  INSTALLMENT_POSTPAID: 'Fixed'
};

const pricingModelValuesMap = {
  SUBSCRIPTION_PREPAID: 'FIXED',
  SUBSCRIPTION_POSTPAID: 'FIXED',
  RECURRING_PREPAID: 'VARIABLE',
  RECURRING_POSTPAID: 'VARIABLE',
  UNSCHEDULED_PREPAID: 'AUTO_RELOAD',
  UNSCHEDULED_POSTPAID: 'AUTO_RELOAD',
  INSTALLMENT_PREPAID: 'FIXED',
  INSTALLMENT_POSTPAID: 'FIXED'
};

export { pricingModelLabelMap, pricingModelValuesMap };
